/**
 * ColumnRow — layout container. Provides the `column` slot.
 * Children stack vertically. The sheet root is an implicit column.
 */
import { LayoutRow } from "./layout-row.ts";

/**
 * The `column` layout row: its children stack vertically in the `column` slot (the sheet root is an
 * implicit column).
 */
export class ColumnRow extends LayoutRow {
  // No additional config beyond the base.
}
